import React from 'react'

export default function Hours() {
    return (
        <table>
            <tbody>

            <tr>
                <td>
                    Mon - Fri
                </td>
                <td>
                    10AM - 6PM
                </td>
            </tr>
            <tr>
                <td>
                    Sun - Sat
                </td>
                <td>
                    10AM - 3PM
                </td>
            </tr>
            </tbody>
        </table>
    )
}
